import React, { FC } from 'react';
import { FeatureServiceFCO } from '../../../core/types/fcoTypes';
import { ErrorBoundary } from '@tecton';
import { TimezoneContextProvider } from '../../context/TimezoneContext';
import { Jobs, FilterProvider } from '../jobs/JobsContainer';
import { JobsContextProvider } from '../jobs/JobsContext';
import { useParams } from 'react-router';
import { FlexGroup, FlexItem } from '@lithos';

interface FeatureServiceJobsProps {
  featureService: FeatureServiceFCO;
}

const FeatureServiceJobs: FC<FeatureServiceJobsProps> = ({ featureService }) => {
  const { workspace } = useParams();
  return (
    <FlexGroup>
      <FlexItem>
        <ErrorBoundary>
          <TimezoneContextProvider>
            <JobsContextProvider feature_service={featureService.name} workspace={workspace}>
              <FilterProvider isFeatureView={true}>
                <Jobs />
              </FilterProvider>{' '}
            </JobsContextProvider>
          </TimezoneContextProvider>
        </ErrorBoundary>
      </FlexItem>
    </FlexGroup>
  );
};

export default FeatureServiceJobs;
